<template>
  <section class="internet-5g-offer space-y-4">
    <div class="rounded-xl bg-white px-6 py-7 md:px-8 md:py-8">
      <div class="flex items-start justify-between gap-4">
        <div>
          <h2 class="text-primary-brand-400 font-extrabold text-2xl leading-tight">
            {{ offer.title }}
          </h2>
          <p class="text-primary-brand-300 font-semibold text-lg leading-none mt-1">
            {{ offer.price }}
          </p>
        </div>

      </div>

      <div class="mt-5 flex items-center gap-2 text-primary-brand-300 font-semibold text-sm">
        <we-icon name="verified" size="22px" classes="fill-contrast-brand-300 shrink-0" />
        Sem fidelidade
      </div>

      <div v-if="offer.features.length" class="mt-8 space-y-4">
        <div
          v-for="feature in offer.features"
          :key="feature.label"
          class="flex items-center gap-3 text-primary-brand-300 font-semibold text-base"
        >
          <span class="w-9 h-9 rounded-full bg-secondary-brand-300 flex items-center justify-center shrink-0">
            <we-icon :name="feature.icon" size="16px" classes="fill-primary-brand-400" />
          </span>
          {{ feature.label }}
        </div>
      </div>
    </div>

    <div class="rounded-xl bg-white px-6 py-6 md:px-8">
      <template v-if="chipError">
        <p class="text-red-500 font-semibold text-sm">Não foi possível consultar os dados do chip. Tente novamente mais tarde.</p>
      </template>
      <template v-else-if="chipName">
        <div class="flex items-start justify-between gap-4">
          <div>
            <h3 class="font-extrabold text-primary-brand-400 text-xl leading-tight">{{ chipName }}</h3>
            <p class="italic text-primary-brand-300 font-semibold text-sm mt-2">
              {{ pixEnabled ? 'Pagamento único via PIX' : 'Pagamento na ativação via WhatsApp' }}
            </p>
          </div>
          <p class="text-primary-brand-300 font-bold text-xl shrink-0">{{ chipPrice }}</p>
        </div>
        <p v-if="!pixEnabled" class="text-primary-brand-300 font-semibold text-sm leading-snug mt-4">
          Seu chip será enviado para o endereço informado. Ao recebê-lo, escaneie o QR Code para ativá-lo pelo WhatsApp e realize o pagamento.
        </p>
      </template>
    </div>

    <div class="rounded-xl bg-white px-6 py-6 md:px-8">
      <p
        v-if="offer.legalNotes"
        class="text-primary-brand-300 text-sm font-semibold leading-snug whitespace-pre-line"
        v-html="offer.legalNotes"
      />
    </div>
  </section>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import WeIcon from '@/components/WeIcon'

const store = useStore()
const pixEnabled = computed(() => store.getters['internet5g/pixEnabled'])

const selectedPlan = computed(() => store.getters.getSelectedPlan)
const chipService = computed(() => store.getters['internet5g/chipService'])

const offer = computed(() => {
  const product = selectedPlan.value?.product ?? {}
  const price = selectedPlan.value?.price ?? {}

  return {
    title: product.title ?? '',
    price: price.full_price ? `R$ ${price.full_price}/mês` : '',
    loyalty: product.observation ?? '',
    features: product.features ?? [],
    legalNotes: product.general_information_details ?? '',
  }
})

const chipError = computed(() => chipService.value.error)
const chipName = computed(() => chipService.value.name ?? null)

const chipPrice = computed(() => {
  const price = chipService.value.price
  if (price === null || price === undefined) return null
  const numeric = parseFloat(String(price).replace(',', '.'))
  if (isNaN(numeric)) return String(price)
  return `R$ ${numeric.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
})

onMounted(() => {
  store.dispatch('internet5g/fetchChipService')
})
</script>
